import { useCallback, useSyncExternalStore } from 'react';

/** Subscribes to a CSS media query. Keep queries in line with the Tailwind breakpoints. */
export const useMediaQuery = (query: string) => {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener('change', onChange);
      return () => mediaQueryList.removeEventListener('change', onChange);
    },
    [query],
  );

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
};

/** Below `lg` (a 1280px screen at 200% zoom) side-by-side layouts stack. */
export const COMPACT_LAYOUT_MEDIA_QUERY = '(max-width: 1023px)';

export const useIsCompactLayout = () => useMediaQuery(COMPACT_LAYOUT_MEDIA_QUERY);
